<div class="ui inverted padded segment">
  <h3>{{ game.title }}</h3>
  <p>{{ game.description }}</p>
</div>
